import type { ComponentProps } from 'react'
import { useMemo } from 'react'
import TravellerSelectionPicker from 'checkout/Components/Cruises/CheckoutV2/TravellerSelectionPicker/TravellerSelectionPicker'
import { MAX_CRUISE_CABIN_LIMIT } from 'constants/cruise'
import { buildCruiseShipRoomCapacities } from 'lib/offer/occupancyUtils'

type TravellerSelectionPickerProps = ComponentProps<typeof TravellerSelectionPicker>

interface Props extends Pick<
  TravellerSelectionPickerProps,
  | 'boundaryRef'
  | 'dropdownSize'
  | 'onApply'
  | 'onChange'
  | 'occupancies'
  | 'placement'
  | 'portaled'
> {
  departureDate: string
  ship: App.CruiseShip
}

function CruiseTravellerSelectionPicker({
  departureDate,
  ship,
  portaled = true,
  ...props
}: Props) {
  const shipOccupancies = ship.occupancies
  const capacities = useMemo(
    () => buildCruiseShipRoomCapacities(shipOccupancies),
    [shipOccupancies],
  )

  return (
    <TravellerSelectionPicker
      {...props}
      portaled={portaled}
      maxRooms={MAX_CRUISE_CABIN_LIMIT}
      saleUnit="cabin"
      capacities={capacities}
      childrenAgeLabel=""
      maxChildAge={shipOccupancies?.childMaximumAge || 17}
      maxInfantAge={shipOccupancies?.infantMaximumAge ?? 2}
      minInfantAge={shipOccupancies?.infantMinimumAge || 0}
      childVariant="date-of-birth"
      departureDate={departureDate}
      enableMultiRoom
    />
  )
}

export default CruiseTravellerSelectionPicker
